import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    fill?: string;
    width?: number;
    height?: number;
};

export const MarkerIcon = ({ fill = 'currentColor', width = 28, height = 28, ...props }: Props) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M5.9668 11.1247C5.9668 16.9258 13.8443 25.1381 13.8443 25.1381C13.8443 25.1381 21.9874 17.2063 22.0345 11.1247C22.0762 5.74091 17.354 2.86328 13.8443 2.86328C10.3345 2.86328 5.9668 5.32358 5.9668 11.1247Z"
                stroke={fill}
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <circle cx="14.0857" cy="11.7459" r="2.25562" stroke={fill} strokeWidth="1.5" strokeLinejoin="round" />
        </svg>
    );
};
